import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from './../../../environments/environment';
import { Parametro } from './../../shared/service-base/parametro';
import { ServiceBase } from './../../shared/service-base/ServiceBase';

@Injectable()
export class HomeService extends ServiceBase {
    private baseUrlService: string
    private url: string
    constructor(http: HttpClient, router: Router) {
        super(http, router);
        this.baseUrlService = environment.URL_API
    }

    protected getURL(): string {
        return this.baseUrlService.concat('/').concat(this.url);
    }

    private definirURLFiltroMarca() {
        this.url = 'dash_filtro_marcas';
    }

    private definirURLTotais() {
        this.url = 'dash_totais';
    }

    private definirURLAberturasOS() {
        this.url = 'aberturas_os';
    }

    private definirURLFechamentosOS() {
        this.url = 'fechamentos_os';
    }

    private getParametrosData(dataInicial: string, dataFinal: string): Parametro[] {
        return [
            new Parametro('data_inicial', dataInicial),
            new Parametro('data_final', dataFinal)
        ];
    }

    public getFiltroMarcas(): Promise<any> {
        this.definirURLFiltroMarca();
        return this.get([]);
    }

    public getTotais(marcas: object): Promise<any> {
        this.definirURLTotais();
        return this.listar([], marcas);
    }

    public getAberturasOS(dataInicial: string, dataFinal: string, marcas: object): Promise<any> {
        this.definirURLAberturasOS();
        return this.listar(this.getParametrosData(dataInicial, dataFinal), marcas);
    }

    public getFechamentosOS(dataInicial: string, dataFinal: string, marcas: object): Promise<any> {
        this.definirURLFechamentosOS();
        return this.listar(this.getParametrosData(dataInicial, dataFinal), marcas);
    }

    public buscar(filtros: object): Promise<any> {
        return this.listar([], filtros);
    }
}
